module.exports = __webpack_public_path__ + "img/tarjetas.a0587e74.jpg";